var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-base',{attrs:{"width":100+'%',"fill":_vm.color,"viewBox":"0 0 351.293 149.435"}},[_c('path',{attrs:{"id":"Path_3105","data-name":"Path 3105","d":"M1009.317,1055.506s92.7,98.762,346.21,42.408","transform":"matrix(-0.966, -0.259, 0.259, -0.966, 1036.54, 1429.355)","fill":"none","stroke":"#eaca42","stroke-width":"3","opacity":"0.6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }